<template>
    <section id="product-type" class="product-type">
        <div class="container">
            <h3 class="product-type-title">{{ $t('product_type.main_title') }}</h3>
            <div class="product-type-content" v-scrollanimation>
                <b-tabs content-class="mt-3" justified>
                    <b-tab :title="$t('product_type.mobile')" active style="margin-top:50px">
                        <carousel
                            dir="ltr"
                            easing="linear"
                            :paginationEnabled="false"
                            :loop="true"
                            :autoplay="true"
                            :autoplayTimeout="2500"
                            :scrollPerPage="false"
                            :navigationEnabled="true"
                            :perPage="size"
                            v-scrollanimation
                        >
                            <slide v-for="(item, index) in mobile" :key="index">
                                <b-card @click="productTypeDetails(item.id)">
                                    <img
                                        :src="item.image"
                                        style="width: 200px;"
                                        :alt="item.title"
                                        height="100%"
                                        width="100%"
                                    />
                                    <b-card-title>{{ item.title }}</b-card-title>
                                </b-card>
                            </slide>
                        </carousel>
                    </b-tab>
                    <b-tab :title="$t('product_type.web')" active style="margin-top:50px">
                        <carousel
                            dir="ltr"
                            easing="linear"
                            :paginationEnabled="false"
                            :loop="true"
                            :autoplay="true"
                            :autoplayTimeout="2500"
                            :scrollPerPage="false"
                            :navigationEnabled="true"
                            :perPage="size"
                        >
                            <slide v-for="(item, index) in web" :key="index">
                                <b-card @click="productTypeDetails(item.id)">
                                    <img
                                        :src="item.image"
                                        style="width: 200px"
                                        :alt="item.title"
                                        height="100%"
                                        width="100%"
                                    />
                                    <b-card-title>{{ item.title }}</b-card-title>
                                </b-card>
                            </slide>
                        </carousel>
                    </b-tab>
                </b-tabs>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "product-type",
    data() {
        return {
            screenWidth: 0,
            size: 0,
            data: [],
            web: [],
            mobile: [],
        };
    },
    methods: {
        productTypeDetails(id) {
            this.$router.replace({ name: 'product-type', params: { id: id } })
        },
        getImage(item) {
            return require("@/assets/img/product_type/" + item.image + ".png")
        },
        onScreenResize() {
            window.addEventListener("resize", () => {
                this.updateScreenWidth();
            });
        },
        updateScreenWidth() {
            this.screenWidth = window.innerWidth
        },
        setSize() {
            if (this.screenWidth >= '992')
                this.size = 4
            else if (this.screenWidth < 991 && this.screenWidth >= 767)
                this.size = 2
            else
                this.size = 1
        },
        initData() {
            this.data = this.$store.state.product_type_data
            this.data.forEach(element => {
                if (element.type == 'Web')
                    this.web.push(element)
                else if (element.type == 'Mobile')
                    this.mobile.push(element)
            });
        },
    },
    created() {
        this.updateScreenWidth()
        this.onScreenResize()
        this.setSize()
    },

    mounted() {
        this.initData()
    }
};
</script>

<style lang="scss">
.product-type {
    padding: 60px 100px 80px;
    // background-color: rgba(231, 231, 231, 0.356);
}

@media (max-width: 991px) {
    .product-type {
        padding: 60px 30px 80px;
    }
}

.product-type .product-type-title {
    text-align: center;
    font-size: 35px;
    font-weight: bold;
    color: var(--main-blue);
    margin-bottom: 60px;
}

///////

.product-type .product-type-content .nav-link.active {
    font-weight: bold;
    border-top: none;
    border-right: none;
    border-left: none;
    color: var(--main-blue);
    border-bottom: 3px solid var(--main-blue);
}

.product-type .nav-tabs .nav-link:hover {
    border-color: transparent;
}

.product-type .nav-tabs .nav-link.active:hover {
    border-top: none;
    border-right: none;
    border-left: none;
    border-bottom: 3px solid var(--main-blue);
}

.product-type .nav-tabs {
    padding: 0px 20px;
}

.product-type .nav-link {
    border-top: none !important;
    border-right: none !important;
    border-left: none !important;
    text-align: center;
    font-weight: lighter;
    color: #727788;
    border-bottom: 2px solid #d9dbe1;
    // cursor: pointer;
    transition: all 0.4s;
}

///////

.product-type .card-title {
    color: var(--main-blue);
    margin-top: 25px;
    // font-weight: 800;
    font-size: 20px;
}

.product-type .card {
    box-shadow: 0 0 10px #0000001f;
    border: none;
    border-radius: 5px;
}

.product-type .card:hover {
    cursor: pointer;

    img {
        transform: scale(1.2, 1.2);
        transition: all 0.5s;
    }
}

.product-type img {
    transition: all 0.5s;
}

.product-type .my-row {
    margin: 30px 20px 0px;
    row-gap: 30px;
}

.product-type .before-enter {
    opacity: 0;
    transform: translateY(100px);
    transition: all 1.5s ease-out;
}

.product-type .enter {
    opacity: 1;
    transform: translateY(0px);
}

.product-type .VueCarousel-navigation-button[data-v-453ad8cd] {
    padding: 10px !important;
    color: var(--main-blue);
}

.product-type .VueCarousel-navigation-button[data-v-453ad8cd]:focus {
    outline: none;
}

.product-type .VueCarousel-slide {
    padding: 10px;
}
</style>